import { Frame } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { EmailTable } from './email-table';
import { getAlignment, getPadding } from './utils';

type SectionFrame = Frame & React.TdHTMLAttributes<HTMLTableCellElement>;

export const SectionFrame = ({
  alignment: passedAlignment,
  backgroundColor, // TODO: Fix the colors. They're all being rendered as rgb() and need to be hex values.
  children,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  ...props
}: SectionFrame) => {
  const padding = getPadding(paddingTop, paddingRight, paddingBottom, paddingLeft);
  const alignment = getAlignment(passedAlignment);

  return (
    <EmailTable alignment={alignment} backgroundColor={backgroundColor}>
      <EmailTable.Row>
        <EmailTable.Cell {...props} alignment={alignment} padding={padding}>
          {children}
        </EmailTable.Cell>
      </EmailTable.Row>
    </EmailTable>
  );
};
